import { loginWithAuth0, loginWithGoogle } from './apiService';
import Cookies from 'js-cookie';

/**
 * Verify password for reauthentication (password users only)
 * @param {string} password - User's password
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const verifyPasswordForReauth = async (password) => {
  try {
    // Get current user's email/username from cookies
    const username = Cookies.get('username');
    
    if (!username) {
      throw new Error('User session not found');
    }

    // Use existing login function to verify password
    // This will fail if password is wrong, succeed if correct
    await loginWithAuth0(username, password);
    
    // If we get here, password is correct
    // We don't need to store the new token, just verify it worked
    return { success: true };
  } catch (error) {
    console.error('Password verification failed:', error);
    return { 
      success: false, 
      error: 'Wrong password.' 
    };
  }
};

/**
 * Verify Google reauthentication (Google users only)
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const verifyGoogleReauth = async () => {
  try {
    // Trigger Google popup login
    await loginWithGoogle();
    return { success: true };
  } catch (error) {
    console.error('Google reauthentication failed:', error);
    return { 
      success: false, 
      error: error.message || 'Reauthentication failed' 
    };
  }
};

/**
 * Detect if user is a Google user based on email or stored metadata
 * @returns {boolean}
 */
export const isGoogleUser = () => {
  const username = Cookies.get('username');
  
  // Simple detection: check if email contains common Google domains
  // You could also store this info during initial login for more accuracy
  const googleDomains = ['@gmail.com', '@googlemail.com'];
  return googleDomains.some(domain => username?.includes(domain));
};

/**
 * Get user's email for display purposes
 * @returns {string}
 */
export const getUserEmail = () => {
  return Cookies.get('username') || 'Unknown User';
};
